import { render, staticRenderFns } from "./NotesStudentSection.vue?vue&type=template&id=0fa87d25&scoped=true"
import script from "./NotesStudentSection.vue?vue&type=script&lang=js"
export * from "./NotesStudentSection.vue?vue&type=script&lang=js"
import style0 from "./NotesStudentSection.vue?vue&type=style&index=0&id=0fa87d25&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa87d25",
  null
  
)

export default component.exports